import logo from "./logo.png";
import React, { useEffect, useState } from "react";
import "./App.css";
// import { Outlet } from "react-router-dom";
import Routing from "./routing";
import { json } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { windowSize } from "./utility";
import PullToRefresh from "react-simple-pull-to-refresh";
import "react-toastify/dist/ReactToastify.css";
import { v4 as uuidv4 } from "uuid";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const { isMobile } = windowSize();
  const query = new URLSearchParams(window.location.search);
  const department = query.get("department");
  const token = query.get("access_token");
  if (department && token) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    const urlencoded = new URLSearchParams();
    urlencoded.append("token", token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(`${process.env.REACT_APP_JAVA_URL}/oauth/check_token`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        for (var el in result) {
          let value = result[el];
          localStorage.setItem(el, el === 'roles' ? JSON.stringify(value) : value);
        }
        localStorage.setItem("access_token", token)
        localStorage.setItem("localDeviceId", uuidv4());
        localStorage.setItem("department", department)
        window.location.href = "/"
        // history.pushState({}, document.title, "/");
      })
      .catch((error) => console.error(error));
  }

  return (
    <>
      <GoogleOAuthProvider clientId="200050510075-8u4kuhtknof3ni9ulil74adnm1vgltb4.apps.googleusercontent.com">
        {isMobile ? (
          <PullToRefresh
            resistance={4}
            onRefresh={() => {
              return new Promise((resolve, reject) => {
                if (isMobile) {
                  setTimeout(() => {
                    resolve(window.location.reload());
                  }, 1000);
                } else {
                  reject();
                }
              });
            }}
          >
            <Routing />
            <ToastContainer />
          </PullToRefresh>
        ) : (
          <>
            <Routing />
            <ToastContainer />
          </>
        )}
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
